var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.33398V13.5007L16.0833 16.084",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93945 12.2087C2.2289 9.36707 3.55438 6.7315 5.66298 4.80479C7.77159 2.87808 10.5157 1.7951 13.3718 1.76248C16.2279 1.72986 18.9961 2.74987 21.1482 4.62792C23.3002 6.50596 24.6856 9.11057 25.0398 11.9448C25.3941 14.7791 24.6926 17.6445 23.069 19.9945C21.4454 22.3445 19.0135 24.0145 16.2373 24.686C13.461 25.3574 10.5347 24.9832 8.01674 23.6348C5.49875 22.2865 3.5653 20.0582 2.58529 17.3753M1.93945 23.8337V17.3753H8.39779",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHistory);
export default __webpack_public_path__ + "static/media/icon-history.d1cba2ccaa407eb8774ee9b36f0a8bf3.svg";
export { ForwardRef as ReactComponent };